import type { User } from '@/@types/user'
import { currentUserQueryOptions, getUserQueryOptions } from '@/utils/fetchers/user'
import storage from '@/utils/Storage'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

export default function useUser(username: string | undefined): User | undefined {
	const { data: user } = useQuery({
		...getUserQueryOptions(username),
		enabled: Boolean(storage.auth.token),
	})
	return user
}

export function useCurrentUser(): User {
	const { data: user } = useSuspenseQuery(currentUserQueryOptions)
	return user
}
